module.exports = __webpack_public_path__ + "media/images/comprar-4f20e5c596334783ffab45fa85ea1d01.png";